<template>
  <div class="buttons has-addons">
    <a class="button" :class="{ 'is-static': activeView === 'homescreen' }" @click="setActiveView('homescreen')"
      >Homescreen</a
    >
    <a class="button" :class="{ 'is-static': activeView === 'conversation' }" @click="setActiveView('conversation')"
      >Conversation</a
    >
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';

defineProps({
  activeView: {
    type: String as PropType<'homescreen' | 'conversation'>,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'viewChange', view: 'homescreen' | 'conversation'): void;
}>();

function setActiveView(view: 'homescreen' | 'conversation') {
  emit('viewChange', view);
}
</script>
